
  Vue.component('vue-dt-column-header', {
    props: {
      id: { type: String, required: true },
      name: {type: String, required: true},
      label: { type: String, required: true },
      sortable: { type: Boolean, default: false },
      sortDirection: { type: Number, default: 1 }
    },
    data() {
      return {        
        directions: [{ id: 1, value: '', icon:'sort' }, { id: 2, value: 'ASC', icon:'sort-down' }, { id: 3, value: 'DESC', icon: 'sort-up' }]
      }
    },
    template: '#vue-datatable-column-header',
    computed: {
      sortIcon() {
        return this.directions.find(item => item.id == this.sortDirection).icon;
      }
    },
    watch: {},
    methods: {
      dummy(param) { },
      changeSorting(event) {
        if (this.sortable) {
          this.$emit('change-sorting', event, this.name)          
        }
      }
    },
    mounted() {
      // EventBus.$on('vnShow', this.vnShow)
    },
    beforeDestroy() {
      // EventBus.$off('vnShow', this.vnShow)
    }
  })
